<template lang="html">
	<div class="content-wy">
		<p>公司文化</p>
	    <table class="table table-hover">
			<template v-for="infodata in infodata">
				<tr v-if="infodata.id!=68">
					<td>{{infodata.content.account}}</td>
					<td style="width: 110px;cursor: pointer;">
						<a href="{{infodata.content.alink}}" target="_blank">
							查看详情
							<span class="glyphicon glyphicon-chevron-right"></span><span class="glyphicon glyphicon-chevron-right"></span>
						</a>
					</td>
				</tr>
			</template>
		</table>
		<page :turn-page="pageData"></page>
	</div>
</template>
<script>
    import 	M from '../assets/common.js'
    import  C from '../assets/config.js'
	import page from '../components/page.vue'
    export default {
        data: () => ({
            host: C.host,
            pageNo:1,
            pageData:{},
            infodata:{},
        }),
        watch: {},
		events: {
			'child-turn-page'(obj){
				this.pageNo = obj.pageNo;
				this.findinfo();
			},
	    },
		components: {
			page
        },
		created: function () {
			this.findinfo();
		},
		ready: function () { 
		
		},
        methods: {
            findinfo:function(){
        		let url = this.host+'wuyan/user/notice';
                let self = this;
                let  postParam ={};
                postParam.pageSize = 20;
                postParam.pageNo =this.pageNo ;
                M.load(url, postParam,function(data){
                	if(data.hasOwnProperty('code')){
                		M.topRightInfoTips({ title:data.message})
                	}else{
                		self.$set('infodata',data.data.list)
                		self.infodata.forEach(function(a){
                            a.content = JSON.parse(a.content);
                        })
                		self.$set('pageData',data.data)
                	}
                },'get');
        	},
        }
    }
</script>
<style scoped>
    .content-wy{
    	margin: 20px auto;
	    width: 980px;
	    padding: 0px 0;
	    border-radius: 3px;
    }
    p{
    	margin: 0;
    	padding: 10px;
    	background: #3dccac;
    	color: #fff;
    }
    table tr td{
    	margin: 0 40px;
    }
</style>


// WEBPACK FOOTER //
// findinfopc.vue?003c0599